import { DateTimePicker, DateTimePickerAndroid } from '@react-native-community/datetimepicker';
import React, { FunctionComponent } from 'react'
import { StyleSheet, Text, View, TextInput, TouchableOpacity } from 'react-native';
import { EvilIcons, Entypo } from '@expo/vector-icons'; 
import MyText from './MyText';
import MyTextInput from './MyTextInput';
import stylesheet from './Style'
import MyTextarea from './MyTextarea';
import { connect } from 'react-redux';
import { openModal, closeModal } from './modalActions';

import * as FileSystem from 'expo-file-system';
import FileViewer from "react-native-file-viewer";
import * as Sharing from 'expo-sharing';

const MyReasonModal = (props) => {
    const css = stylesheet();

    const Open = () => {
        FileViewer.open(props.uri);
        props.close();
    }
    
    const Share = () => {
        Sharing.shareAsync(props.uri, {
            dialogTitle: 'Share file'
        })
        props.close();
    }

    const Delete = async() => {
        props.openModal("Warning", "Are you sure you want to Delete this document?", async() => {
            await FileSystem.deleteAsync(props.uri);
            props.refresh();
            props.close();
        });
    }

    return (
        <>
            {props.enabled &&
                <View style={styles.bg}>
                    <View style={styles.modal}>
                        <View style={styles.header}>
                            <MyText style={[css.ml, {color: '#461b6f'}, css.bold]}>
                                {props.name}
                            </MyText>
                        </View>
                        <View style={styles.body}>
                            <TouchableOpacity style={styles.btn} onPress={Open}>
                                <MyText style={css.m}>Open</MyText>
                            </TouchableOpacity>
                            <TouchableOpacity style={styles.btn} onPress={Share}>
                                <MyText style={css.m}>Share</MyText>
                            </TouchableOpacity>
                            <TouchableOpacity style={styles.btn} onPress={Delete}>
                                <MyText style={css.m}>Delete</MyText>
                            </TouchableOpacity>
                        </View>
                        <View style={styles.footer}>
                            <TouchableOpacity onPress={props.close} style={{alignItems: 'center', marginBottom: 0}}>
                                <MyText style={[{paddingVertical: 10, paddingHorizontal: 30, backgroundColor: '#461b6f', color: 'white', borderRadius: 12, overflow: 'hidden'}, css.bold]}>
                                    Cancel
                                </MyText>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            }
        </>
    );
}
const styles = StyleSheet.create({
    bg: {
        backgroundColor: 'rgba(0, 0, 0, 0.38)',
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        backgroundColor: 'white',
        borderRadius: 8,
        width: 350,
        maxWidth: '95%',
        overflow: 'hidden'
    },
    header: {
        padding: 10,
        alignItems: 'center'
    },
    body: {
        borderTopWidth: 1,
        borderTopColor: '#dee2e6',
        borderBottomColor: '#dee2e6',
        padding: 15,
        paddingBottom: 5,
        alignItems: 'center',
        textAlign: 'center'
    },
    footer: {
        padding: 10,
        // flex: 1,
        // display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    btn: {
        marginBottom: 10
    }
})
const mapDispatchToProps = {
    openModal,
    closeModal,
}

export default connect(null, mapDispatchToProps)(MyReasonModal)
